import { FaPersonDigging } from "react-icons/fa6";
import { useSelector } from "react-redux";
import DashboardKabagTransport from "../../features/dashboard/dashboard-kabag-transport/components/dashboard-kabag-transport";

const HomePage = () => {
  const permissions = useSelector((state) => state.auth.permissions);

  if (
    permissions.includes("view it") ||
    permissions.includes("update kabag-transport") ||
    permissions.includes("update pnj-transport") ||
    permissions.includes("update pnj") ||
    permissions.includes("update adm-transport")
  ) {
    return <DashboardKabagTransport />;
  }

  return (
    <div className="w-full col-center-center h-screen gap-2">
      <FaPersonDigging className="text-slate-300 text-7xl" />
      <span className="text-slate-300 font-semibold">
        Construction in progress
      </span>
    </div>
  );
};

export default HomePage;
